import {
  Box,
  Typography,
  TextField,
  Button,
  FormHelperText,
  Stack,
  Input,
  InputAdornment,
  IconButton,
  Paper,
  MenuItem,
  Collapse,
  Chip,
} from "@mui/material";
import NavigateBackButton from "../../../../shared/components/customNavigateButton/customNavigateButton";
import CustomSpinner from "../../../../shared/components/customSpinner/customSpinner";
import {
  CONFIGURATION_CONSTANTS,
  CONTACT_DETAILS,
  MESSAGE_TYPES,
  ORDER_STATUS,
  CONTRACT_WIZARD_ITEMS,
  Order_Contact_Purpose_Type,
  PAGES_URL,
  UOM_TYPE,
  cookieNames,
} from "../../../../shared/constants/constants";
import React, { useEffect, useState } from "react";

import "./rateContractWizard.scss";
import {
  validateOrder,
  validateRateContract,
} from "../../../../shared/utils/validator";
import { useNavigate } from "react-router";
import { getUOMByType } from "../../../../store/api/common";
import store from "../../../../store/store";
import { getAllProductTypesApi } from "../../../../store/api/rfq";
import {
  fetchOrgPartyDetailsApi,
  setPartyProductTypeAPI,
} from "../../../../store/api/party";
import { searchProducts } from "../../../../store/api/product";
import { getPartyPref } from "../../../../store/api/configuration";
import {
  getSessionVariable,
  getUserContext,
} from "../../../../shared/utils/utils";
import dayjs from "dayjs";
import { Cancel, ClearOutlined, Search } from "@mui/icons-material";
import CustomTooltip from "../../../../shared/components/customTooltip/customTooltip";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { getPartyContactDetails } from "../../../../store/api/order";
import customParseFormat from "dayjs/plugin/customParseFormat";
import PrismAIBar from "../../../../components/pageBars/prismAI/prismAIBar";
import PageMessage from "../../../../components/pageMessage/pageMessage";
import OrderDocument from "../../../../components/order/orderDocument/orderDocument";
import ErrorPopup from "../../../../components/dialogBox/errorModal";
import TermsConditionsBar from "../../../../components/pageBars/termsConditionsBar/termsConditionsBar";
import RateContractInputTable from "../RateContractInputTable/rateContractInputTable";
import RateContractDocument from "../RateContractDocument/rateContractDocument";

type ContractWizardProps = {
  isEdit: any;
  handleCreateContract: (a: string, b: any) => void;
  isLoading: boolean;
};

export type ContractItemType = {
  item: string;
  itemTypeId: string;
  brandName: string;
  size: string;
  description: string;
  // quantityUOM: string;
  quantity: string;
  pricePerUnit: any;
  finalUnitPrice: any;
  taxableAmount: any;
  gst: any;
  taxAmount: any;
  amount: any;
  content: any[];
  comment: string;
  productId: string;
  hsnCode: string;
};

export type ContractHeadType = {
  locations: string[];
  rateContractName: string;
  description: string;
  validTillDate: any | null;
  fulfilledByPartyId: string;
  paymentTerms: string;
  termsNConditions: string;
  // adjustments: any;
  hsnAck: any;
  // grandTotal: any;
  // totalTaxAmount: any;
  // totalAmount: any;
  // contractContactMechs: any;
  items: any;
  // totalAdjustedAmount: any;
  // totalAmountWithoutAdjustment: any;
  rateContractAmountLimit: number;
  billingAddress: any;
  shippingAddress: any;
};

const RateContractWizard = ({
  isEdit,
  handleCreateContract,
  isLoading,
}: ContractWizardProps) => {
  const [uploadedContractByFile, setUploadedContractByFile] = useState<any>({});
  const [contractHeadData, setContractHeadData] = useState<ContractHeadType>({
    locations:
      uploadedContractByFile && uploadedContractByFile.locationNames
        ? uploadedContractByFile.locationNames
        : [],
    rateContractName:
      uploadedContractByFile && uploadedContractByFile.rateContractName
        ? uploadedContractByFile.rateContractName
        : "",
    description:
      uploadedContractByFile && uploadedContractByFile.description
        ? uploadedContractByFile.description
        : "",
    // customPONumber:
    //   uploadedContractByFile && uploadedContractByFile.rateContractNumber
    //     ? uploadedContractByFile.rateContractNumber
    //     : "",
    // referenceDate:
    //   uploadedContractByFile && uploadedContractByFile.rateContractDate
    //     ? uploadedContractByFile.rateContractDate
    //     : "",
    validTillDate:
      uploadedContractByFile && uploadedContractByFile.rateContractDate
        ? uploadedContractByFile.rateContractDate
        : dayjs(new Date()),
    fulfilledByPartyId: "",
    paymentTerms:
      uploadedContractByFile && uploadedContractByFile.paymentTerms
        ? uploadedContractByFile.paymentTerms
        : "",
    termsNConditions:
      uploadedContractByFile && uploadedContractByFile.termsNConditions
        ? uploadedContractByFile.termsNConditions
        : "",
    // adjustments:
    //   uploadedContractByFile && uploadedContractByFile.adjustments
    //     ? uploadedContractByFile.adjustments
    //     : [],
    hsnAck: false,
    // grandTotal:
    //   uploadedContractByFile && uploadedContractByFile.grandTotal
    //     ? uploadedContractByFile.grandTotal
    //     : "",
    // totalTaxAmount:
    //   uploadedContractByFile && uploadedContractByFile.totalTaxAmount
    //     ? uploadedContractByFile.totalTaxAmount
    //     : "",
    // totalAmount:
    //   uploadedContractByFile && uploadedContractByFile.totalAmount
    //     ? uploadedContractByFile.totalAmount
    //     : "",
    // totalAdjustedAmount:
    //   uploadedContractByFile && uploadedContractByFile.finalTotalAdjustedAmount
    //     ? uploadedContractByFile.finalTotalAdjustedAmount
    //     : "",
    // totalAmountWithoutAdjustment:
    //   uploadedContractByFile &&
    //   uploadedContractByFile.totalAmountWithoutAdjustment
    //     ? uploadedContractByFile.totalAmountWithoutAdjustment
    //     : "",
    items: [],
    rateContractAmountLimit:
      uploadedContractByFile && uploadedContractByFile.rateContractAmountLimit
        ? uploadedContractByFile.rateContractAmountLimit
        : 0,
    billingAddress:
      uploadedContractByFile && uploadedContractByFile.billingAddress
        ? uploadedContractByFile.billingAddress
        : {},
    shippingAddress:
      uploadedContractByFile && uploadedContractByFile.shippingAddress
        ? uploadedContractByFile.shippingAddress
        : {},
  });

  const [validationErrors, setValidationErrors] = useState<any>({});
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [openTermsDialog, setOpenTermsDialog] = useState<boolean>(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [openHsn, setOpenHsn] = useState<boolean>(false);
  const [itemUom, setItemUom] = useState([]);
  const [productTypes, setProductTypes] = useState<any>([]);
  const [productTypesMap, setProductTypeMaps] = useState<any>({});
  const [products, setProducts] = useState([]);
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);
  const [isLoadingDraft, setIsLoadingDraft] = useState<boolean>(false);
  const [currentSeller, setCurrentSeller] = useState<string>("");
  const [currentSellerGST, setCurrentSellerGST] = useState<string>("");
  const [selectedSeller, setSelectedSeller] = useState<string>("");
  const [relations, setRelations] = useState<any>([]);
  const [fileContractData, setFileContractData] = useState(null);
  const [addressList, setAddressList] = useState<any>([]);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState<any>({});
  const [selectedShippingAddress, setSelectedShippingAddress] = useState<any>(
    {}
  );
  const [adjustments, setAdjustments] = useState<any>([]);

  dayjs.extend(customParseFormat);
  const navigate = useNavigate();

  useEffect(() => {
    const dispatchers = async () => {
      const categoryCheck: any = {};
      const categoryObj: any = {};
      const prismUser = getSessionVariable(cookieNames.prismUser);
      let partyId = "";
      if (prismUser && prismUser != "") {
        partyId = JSON.parse(prismUser).orgPartyIds[0];
      }

      store
        .dispatch(getUOMByType(UOM_TYPE.QUANTITY_MEASURE))
        .unwrap()
        .then((res) => {
          if (res.status === 200) {
            setItemUom(res.data);
          }
        });
      await store
        .dispatch(getAllProductTypesApi())
        .unwrap()
        .then((res: any) => {
          const categoryMap: any = {};
          setPartyProductTypeAPI(res.data);
          res.data.forEach((el: any) => {
            categoryMap[el._id] = el.name;
            categoryCheck[el._id] = false;
          }, {});
          setProductTypeMaps({ ...categoryMap });
        })
        .catch((error: any) => {
          console.log("Failed to fetch all productTypes");
        });

      store
        .dispatch(getPartyContactDetails(partyId))
        .unwrap()
        .then((res) => {
          let buyer: any = {};
          let addressListData: any = [];
          let billingAddress: any = {};
          let shippingAddress: any = {};
          let primaryPostalAddress: any;
          let billingAddressFound = false;
          let shippingAddressFound = false;

          res?.data?.forEach((element: any) => {
            if (element["contactmechType"] === CONTACT_DETAILS.CONTACT_MECH.EMAIL_ADDRESS) {
              buyer[CONTACT_DETAILS.CONTACT_MECH.EMAIL_ADDRESS] = element["detail"]
                ? element["detail"]
                : "";
            } else if (
              element["contactmechType"] === CONTACT_DETAILS.CONTACT_MECH.POSTAL_ADDRESS
            ) {
              addressListData.push(element);
              if (
                element["purposeType"] &&
                element["purposeType"].includes(
                  Order_Contact_Purpose_Type.BILLING_LOCATION
                )
              ) {
                billingAddress = element;
              } else if (
                element["purposeType"] &&
                element["purposeType"].includes(
                  Order_Contact_Purpose_Type.SHIPPING_LOCATION
                )
              ) {
                shippingAddress = element;
                billingAddressFound = true;
                shippingAddressFound = true;
              }
              primaryPostalAddress = element;
              buyer[CONTACT_DETAILS.CONTACT_MECH.POSTAL_ADDRESS] = element["detail"];
            } else if (
              element["contactmechType"] === CONTACT_DETAILS.CONTACT_MECH.TELECOM_NUMBER
            ) {
              buyer[CONTACT_DETAILS.CONTACT_MECH.TELECOM_NUMBER] = element["detail"]
                ? element["detail"]
                : "";
            }
          });

          if (!billingAddressFound) {
            billingAddress = primaryPostalAddress;
          }
          if (!shippingAddressFound) {
            shippingAddress = primaryPostalAddress;
          }
          setSelectedBillingAddress(billingAddress);
          setSelectedShippingAddress(shippingAddress);
          // let contractContactMechs: any = [];
          // contractContactMechs.push(selectedBillingAddress);
          // contractContactMechs.push(selectedShippingAddress);
          setAddressList(addressListData);
          setContractHeadData({
            ...contractHeadData,
            billingAddress: billingAddress.detail,
            shippingAddress: shippingAddress.detail,
          });
        });

      store
        .dispatch(searchProducts({ pageSize: 10000 }))
        .unwrap()
        .then((res) => {
          if (res.status === 200) {
            setProducts(res.data?.products);
          } else {
            setError({
              open: true,
              message:
                res?.data?.message ??
                res?.error ??
                "Error while fetching products.",
            });
          }
        })
        .catch((error) => {
          setError({
            open: true,
            message: error?.error ?? "Error while fetching products.",
          });
        });

      if (uploadedContractByFile) {
        const processedContractItems: any = [];
        // console.log(uploadedContractByFile)
        let totalAmount = 0;
        let taxAmount = 0;
        let grandTotal = 0;
        uploadedContractByFile?.items?.forEach((rawContractItem: any) => {
          const newContractItem = {
            item: rawContractItem.item,
            itemTypeId: rawContractItem.itemTypeId,
            brandName: rawContractItem.brandName,
            size: rawContractItem.size,
            // quantity: rawContractItem.quantity,
            // quantityUOM: rawContractItem.quantityUOM,
            description: rawContractItem.description,
            pricePerUnit: rawContractItem.unitPrice,
            finalUnitPrice: rawContractItem.finalUnitPrice,
            taxableAmount: rawContractItem.taxableAmount,
            gst: rawContractItem.gst,
            taxAmount: rawContractItem.taxAmount,
            amount: rawContractItem.amount,
            content: [],
            comment: "",
            hsnCode: rawContractItem.hsnCode,
          };
          totalAmount += Number(rawContractItem.taxableAmount);
          taxAmount += Number(rawContractItem.taxAmount);
          grandTotal += Number(
            rawContractItem.taxableAmount + rawContractItem.taxAmount
          );
          processedContractItems.push(newContractItem);
        });
        if (uploadedContractByFile?.adjustments) {
          uploadedContractByFile?.adjustments?.forEach((adjustment: any) => {
            adjustment.taxPercentage = Number(
              typeof adjustment.taxPercentage === "string"
                ? adjustment.taxPercentage?.replace("%", "")
                : adjustment.taxPercentage
            );
            adjustment.adjustmentTotal =
              Number(adjustment.adjustmentAmount) +
              Number(
                adjustment.adjustmentAmount * (adjustment.taxPercentage / 100)
              );
            adjustment.adjustmentTax = Number(
              adjustment.adjustmentAmount * (adjustment.taxPercentage / 100)
            );
          });
          setAdjustments([...uploadedContractByFile?.adjustments]);
        }
        // console.log({
        //     totalAmount: totalAmount, totalTaxAmount: taxAmount, grandTotal: grandTotal
        // })
        setContractHeadData({
          ...contractHeadData,
          items: processedContractItems,
          // totalAmount: totalAmount,
          // totalTaxAmount: taxAmount,
          // grandTotal: grandTotal,
        });
      } else {
        await store
          .dispatch(getPartyPref(partyId))
          .unwrap()
          .then((res) => {
            const data = res.data;
            let paymentTerm = "";
            for (let i = 0; i < data.length; i++) {
              if (
                data[i].preferenceTypeId ===
                CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PAYMENT_TERMS
              ) {
                paymentTerm = data[i].prefValue;
                break;
              }
            }
            setContractHeadData({
              ...contractHeadData,
              paymentTerms: paymentTerm,
            });
          });
      }
    };
    dispatchers();
  }, [uploadedContractByFile]);

  useEffect(() => {
    store
      .dispatch(
        fetchOrgPartyDetailsApi({
          relationshipType: "PREFERRED_VENDOR",
          pageSize: Number.MAX_SAFE_INTEGER,
        })
      )
      .unwrap()
      .then((res: any) => {
        //console.log(res);
        setRelations(res.data.parties);
      });
  }, []);

  const handleAddContractRow = () => {
    if (validationErrors?.itemsDiv) {
      resetValidationError("itemsDiv");
    }
    const newRow: ContractItemType = {
      item: "",
      itemTypeId: "",
      brandName: "",
      size: "",
      description: "",
      // quantityUOM: "",
      quantity: "1",
      pricePerUnit: "",
      finalUnitPrice: "",
      taxableAmount: "",
      gst: "",
      taxAmount: "",
      amount: "",
      content: [],
      comment: "",
      hsnCode: "",
      productId: "",
    };
    setContractHeadData((prevData) => ({
      ...prevData,
      items: [...(prevData.items || []), newRow],
    }));
  };

  const parseAndFormatDate = (dateString: any) => {
    const knownFormats = [
      "DD-MM-YYYY",
      "DD/MM/YYYY",
      "YYYY-MM-DD",
      "YYYY-MM-DDTHH:mm:ssZ",
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
    ];

    const parsed = dayjs(dateString, knownFormats, true);
    return parsed.isValid()
      ? parsed.format("DD-MM-YYYY")
      : dayjs().format("DD-MM-YYYY");
  };

  const handleValidations = (requestType: string) => {
    const userContext: any = getUserContext();
    let orgPartyIdFromSession = "";
    if (userContext && userContext.orgPartyIds) {
      orgPartyIdFromSession = userContext?.orgPartyIds[0];
    }
    const orgPartyId: any = orgPartyIdFromSession;
    const contractReqBody: any = {
      ...contractHeadData,
      orgPartyId: orgPartyId,
      fromPartyId: "",
      statusId: requestType,
      hsnAck: true,
      adjustments: [...adjustments],
      fulfilledByPartyId: selectedSeller,
      validTillDate: dayjs(contractHeadData.validTillDate).format("YYYY-MM-DD"),
    };

    let isValid: boolean = validateInputs(contractReqBody);
    //console.log("valid errors", orderReqBody, validationErrors)
    if (isValid) {
      setOpenHsn(true);
    }
  };

  const validateInputs = (contract: any): boolean => {
    const errorItem = validateRateContract(contract);
    if (errorItem?.length > 0) {
      let errorsObject: any = {};
      errorItem.forEach((item: any) => {
        errorsObject[item.elementId] = item.message;
      });
      setValidationErrors({ ...errorsObject });
      return false;
    }
    return true;
  };

  const handleSubmitContract = (requestType: string) => {
    if (requestType === ORDER_STATUS.DRAFT) {
      setIsLoadingDraft(true);
    } else {
      setIsLoadingSave(true);
    }
    const userContext: any = getUserContext();
    let orgPartyIdFromSession = "";
    if (userContext && userContext.orgPartyIds) {
      orgPartyIdFromSession = userContext?.orgPartyIds[0];
    }
    const orgPartyId: any = orgPartyIdFromSession;

    const contractReqBody: any = {
      ...contractHeadData,
      orgPartyId: orgPartyId,
      fromPartyId: "",
      statusId: requestType,
      hsnAck: true,
      adjustments: [...adjustments],
      fulfilledByPartyId: selectedSeller,
      validTillDate: dayjs(contractHeadData.validTillDate).format("YYYY-MM-DD"),
    };

    if (requestType === "ORDER_DRAFT") {
      contractReqBody.statusId = requestType;
    } else {
      contractReqBody.statusId = "ORDER_CREATED";
    }
    handleCreateContract(requestType, contractReqBody);
  };

  const handleCloseError = () => {
    setError({ ...error, open: false });
  };

  const resetValidationError = (errorName: string) => {
    const validationObject = validationErrors;
    if (errorName && errorName in validationErrors) {
      delete validationObject[errorName];
      setValidationErrors(validationObject);
    }
  };

  const handleUploadedContractData = (data: any) => {
    setFileContractData(data);
    if (data?.items) {
      const map: any = {};
      data.items.forEach((orderItem: any) => {
        if (orderItem.requestItemSeqId) {
          map[orderItem.requestItemSeqId] = {
            price: orderItem.finalUnitPrice || 0,
            gst: orderItem.gst || 0,
            amount: orderItem.amount || 0,
          };
        }
      });

      setUploadedContractByFile(data);
      //console.log("uploadedContractByFile :: ", data);
      updateContractHeadData(data);
    }
  };

  const updateContractHeadData = (parsedFileData: any) => {
    const processedContractItems: any = [];
    let totalAmount = 0;
    let taxAmount = 0;
    let grandTotal = 0;
    parsedFileData?.items?.forEach((rawContractItem: any) => {
      const itemCalculations = {
        taxableAmount: 0,
        taxAmount: 0,
        amount: 0,
      };
      // Without quantity to capture unit price only
      itemCalculations.taxableAmount = Number(
        (Math.round(rawContractItem.finalUnitPrice * 100) / 100).toFixed(2)
      );
      itemCalculations.taxAmount = Number(
        (
          Math.round(itemCalculations.taxableAmount * rawContractItem.gst) / 100
        ).toFixed(2)
      );
      itemCalculations.amount = Number(
        (
          Math.round(
            (itemCalculations.taxableAmount + itemCalculations.taxAmount) * 100
          ) / 100
        ).toFixed(2)
      );

      const newContractItem = {
        item: rawContractItem.item,
        itemTypeId: rawContractItem.itemTypeId,
        brandName: rawContractItem.brandName,
        size: rawContractItem.size,
        quantity: 1, // Just for calculation purposes
        quantityUOM: rawContractItem.quantityUOM,
        description: rawContractItem.description,
        pricePerUnit: rawContractItem.unitPrice,
        finalUnitPrice: rawContractItem.finalUnitPrice,
        taxableAmount: itemCalculations.taxableAmount,
        gst: rawContractItem.gst || 0,
        taxAmount: itemCalculations.taxAmount,
        amount: itemCalculations.amount, // Not amount since AI was returning it as quantity  multiplied,
        content: [],
        comment: "",
        hsnCode: rawContractItem.hsnCode,
      };
      totalAmount += Number(itemCalculations.taxableAmount);
      taxAmount += Number(itemCalculations.taxAmount);
      grandTotal += Number(
        itemCalculations.taxableAmount + itemCalculations.taxAmount
      );
      processedContractItems.push(newContractItem);
    });
    setContractHeadData({
      ...contractHeadData,
      locations:
        parsedFileData && parsedFileData.locationNames
          ? parsedFileData.locationNames
          : [],
      rateContractName:
        parsedFileData && parsedFileData.rateContractName
          ? parsedFileData.rateContractName
          : "",
      description:
        parsedFileData && parsedFileData.description
          ? parsedFileData.description
          : "",
      // customPONumber:
      //   parsedFileData && parsedFileData.rateContractNumber
      //     ? parsedFileData.rateContractNumber
      // : "",
      // referenceDate:
      //   parsedFileData && parsedFileData.rateContractDate
      //     ? parseAndFormatDate(parsedFileData.rateContractDate)
      //     : dayjs().format("DD-MM-YYYY"),
      validTillDate:
        parsedFileData && parsedFileData?.rateContractDate
          ? dayjs(parsedFileData.rateContractDate)
              .add(10, "day")
              .format("DD-MM-YYYY")
          : dayjs().add(10, "day").format("DD-MM-YYYY"),
      fulfilledByPartyId: "",
      paymentTerms:
        parsedFileData && parsedFileData.paymentTerms
          ? parsedFileData.paymentTerms
          : "",
      termsNConditions:
        parsedFileData && parsedFileData.termsNConditions
          ? parsedFileData.termsNConditions
          : "",
      hsnAck: false,
      // grandTotal: parsedFileData && parsedFileData.grandTotal ? parsedFileData.grandTotal : '',
      // grandTotal: grandTotal,
      // totalTaxAmount: parsedFileData && parsedFileData.totalTaxAmount ? parsedFileData.totalTaxAmount : '',
      // totalTaxAmount: taxAmount,
      // totalAmount: parsedFileData && parsedFileData.totalAmount ? parsedFileData.totalAmount : '',
      // totalAmount: totalAmount,
      items: processedContractItems,
      // adjustments:
      //   parsedFileData && parsedFileData.adjustments
      //     ? parsedFileData.adjustments
      //     : [],
      // totalAdjustedAmount:
      //   parsedFileData && parsedFileData.finalTotalAdjustedAmount
      //     ? parsedFileData.finalTotalAdjustedAmount
      //     : "",
      // totalAmountWithoutAdjustment:
      //   parsedFileData && parsedFileData.totalAmountWithoutAdjustment
      //     ? parsedFileData.totalAmountWithoutAdjustment
      //     : "",
    });
  };

  return (
    <Box
      flex={1}
      flexGrow={1}
      sx={{
        width: 1,
        backgroundColor: "#fff",
        py: 4,
        px: {
          xs: 2,
          sm: 4,
        },
      }}
      className="order-wizard"
    >
      <NavigateBackButton
        label="Back to Rate Contracts"
        navigateLink={`${PAGES_URL?.ORDERMGR}/${PAGES_URL.RATE_CONTRACT_LIST}`}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          justifyContent: "space-between",
          alignContent: "center",
          my: 4,
        }}
      >
        <Typography variant="h4" fontWeight={"bold"}>
          Create Contract
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor: "#fff",
          my: 2,
          boxShadow: 3,
          py: 4,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        {/* <PrismAIBar
          styling={{ mx: 6, p: 2 }}
          heading="AI enabled contract with HSN enablement"
          content="Prism’s AI suggests HSN code based on your items saving you hassle for manual HSN lookups using natural language."
        /> */}
        <Stack mb={2} px={6} spacing={2}>
          <Stack>
            <Typography style={{ fontWeight: "bold" }}>Seller name</Typography>
            <Stack>
              <Input
                // fullWidth
                sx={{
                  backgroundColor: "#f6f6f6",
                  px: 2,
                  py: 1,
                }}
                value={currentSeller}
                endAdornment={
                  <InputAdornment position="end">
                    {selectedSeller === "" || isEdit ? (
                      <Search />
                    ) : (
                      <IconButton
                        onClick={() => {
                          setSelectedSeller("");
                          setCurrentSeller("");
                          setCurrentSellerGST("");
                        }}
                      >
                        <Cancel />
                      </IconButton>
                    )}
                  </InputAdornment>
                }
                onChange={(event: any) => {
                  setCurrentSeller(event.target.value);
                }}
                disabled={isEdit || selectedSeller !== ""}
              />
              {selectedSeller === "" && currentSeller && (
                <Paper>
                  {relations
                    .filter((vendor: any) =>
                      vendor?.details?.groupName
                        ?.toLowerCase()
                        ?.includes(currentSeller?.toLowerCase())
                    )
                    .map((vendor: any, index: number) => (
                      <MenuItem
                        key={index}
                        value={vendor._id}
                        onClick={() => {
                          setSelectedSeller(vendor?._id);
                          setCurrentSeller(vendor?.details?.groupName);
                          setCurrentSellerGST(vendor?.details?.gstNumber);
                          setContractHeadData((prevData) => ({
                            ...prevData,
                            fulfilledByPartyId: vendor?._id,
                          }));
                        }}
                      >
                        {vendor.details?.groupName}
                      </MenuItem>
                    ))}
                </Paper>
              )}
              {/* </Input> */}
            </Stack>
          </Stack>
          {selectedSeller === "" && (
            <PageMessage
              content="Ensure seller is added before you can create contract"
              link={`${PAGES_URL.DASHBOARD}/${PAGES_URL.SELLER_ONBOARDING}`}
              linkContent="Set Preferred Seller"
              type={MESSAGE_TYPES.INFO}
              state={{
                view: "REGISTER_SELLER",
                from: {
                  type: "ORDER",
                },
              }}
            />
          )}
          {selectedSeller !== "" && currentSellerGST === "" && (
            <PageMessage
              content="The seller is not registered under GST as per Section 23 of the CGST Act, 2017. No GST will be charged on supplies made by the seller, and the buyer will not be eligible to claim Input Tax Credit (ITC) against these purchases."
              type={MESSAGE_TYPES.INFO}
            />
          )}
        </Stack>

        <Collapse in={selectedSeller !== ""}>
          <RateContractDocument
            handleUploadedContractData={handleUploadedContractData}
          />
          <Stack
            px={2}
            py={1}
            direction={{ md: "row", xs: "column" }}
            spacing={2}
          >
            <Box
              sx={{
                px: 4,
                width: { md: "50%", xs: "100%" },
              }}
            >
              <Typography fontWeight={700} fontSize={16}>
                {CONTRACT_WIZARD_ITEMS?.CONTRACT_NAME?.label}
              </Typography>
              <TextField
                fullWidth
                name="rateContractName"
                placeholder={CONTRACT_WIZARD_ITEMS?.CONTRACT_NAME?.placeholder}
                size="medium"
                sx={{
                  backgroundColor: "#f6f6f6",
                }}
                value={
                  contractHeadData?.rateContractName ||
                  contractHeadData?.rateContractName
                }
                error={validationErrors?.rateContractName}
                onChange={(event: any) => {
                  setContractHeadData((prevData) => ({
                    ...prevData,
                    rateContractName: event?.target?.value,
                  }));
                  resetValidationError("rateContractName");
                }}
              />
              <FormHelperText error={validationErrors?.rateContractName}>
                {validationErrors?.rateContractName}
              </FormHelperText>
            </Box>

            <Box
              sx={{
                px: 4,
                width: { md: "50%", xs: "100%" },
              }}
            >
              <CustomTooltip
                title={
                  CONTRACT_WIZARD_ITEMS?.CONTRACT_VALIDITY_DATE?.tooltipTitle
                }
                tooltipProps={{
                  placement: "bottom-end",
                }}
              >
                <span
                  style={{ display: "block", height: "100%", width: "100%" }}
                >
                  <Typography fontWeight={700} fontSize={16}>
                    {CONTRACT_WIZARD_ITEMS?.CONTRACT_VALIDITY_DATE?.label}
                  </Typography>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      slotProps={{
                        textField: {
                          placeholder:
                            CONTRACT_WIZARD_ITEMS?.CONTRACT_VALIDITY_DATE
                              ?.placeholder,
                          size: "medium",
                          fullWidth: true,
                          error: validationErrors?.validTillDate,
                        },
                      }}
                      value={
                        contractHeadData?.validTillDate
                          ? dayjs(contractHeadData.validTillDate, "DD-MM-YYYY")
                          : dayjs()
                      }
                      format="DD-MM-YYYY"
                      onChange={(date: any) => {
                        setContractHeadData((prevData) => ({
                          ...prevData,
                          validTillDate: dayjs(date, "DD-MM-YYYY"),
                        }));
                        resetValidationError("referenceDate");
                      }}
                      sx={{
                        backgroundColor: "#f6f6f6",
                      }}
                    />
                    <FormHelperText error={validationErrors?.validTillDate}>
                      {validationErrors?.validTillDate}
                    </FormHelperText>
                  </LocalizationProvider>
                </span>
              </CustomTooltip>
            </Box>
          </Stack>

          {/* <Stack px={2} direction={"row"} spacing={2}>
                        <Box sx={{
                            px: 4,
                            width: "50%",
                        }}>
                            <CustomTooltip
                                title={
                                    CONTRACT_WIZARD_ITEMS?.CONTRACT_REFERENCE_DATE?.tooltipTitle
                                }
                                tooltipProps={{
                                    placement: "bottom-end",
                                }}
                            >
                                <span
                                    style={{ display: "block", height: "100%", width: "100%" }}
                                >
                                    <Typography>
                                        {CONTRACT_WIZARD_ITEMS?.CONTRACT_REFERENCE_DATE?.label}
                                    </Typography>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    placeholder:
                                                        CONTRACT_WIZARD_ITEMS?.CONTRACT_REFERENCE_DATE
                                                            ?.placeholder,
                                                    size: "medium",
                                                    fullWidth: true,
                                                    error: validationErrors?.referenceDate,
                                                },
                                            }}
                                            value={contractHeadData?.referenceDate ? dayjs(contractHeadData.referenceDate) : dayjs()}
                                            minDate={
                                                contractHeadData?.referenceDate
                                                    ? dayjs(contractHeadData.referenceDate)
                                                    : dayjs() // fallback to today if null
                                            }
                                            format="DD-MM-YYYY"
                                            onChange={(date: any) => {
                                                setContractHeadData((prevData) => ({
                                                    ...prevData,
                                                    referenceDate: date,
                                                }));
                                                resetValidationError("referenceDate");
                                            }}
                                            sx={{
                                                backgroundColor: "#f6f6f6",
                                            }}
                                        />
                                        <FormHelperText
                                            error={validationErrors?.referenceDate}
                                        >
                                            {validationErrors?.referenceDate}
                                        </FormHelperText>
                                    </LocalizationProvider>

                                </span>
                            </CustomTooltip>
                        </Box>

                        <Box sx={{
                            px: 4,
                            width: "50%",
                        }}>
                            <CustomTooltip
                                title={
                                    CONTRACT_WIZARD_ITEMS?.CONTRACT_DELIVERY_DATE?.tooltipTitle
                                }
                                tooltipProps={{
                                    placement: "bottom-end",
                                }}
                            >
                                <span
                                    style={{ display: "block", height: "100%", width: "100%" }}
                                >
                                    <Typography>
                                        {CONTRACT_WIZARD_ITEMS?.CONTRACT_DELIVERY_DATE?.label}
                                    </Typography>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    placeholder:
                                                        CONTRACT_WIZARD_ITEMS?.CONTRACT_DELIVERY_DATE
                                                            ?.placeholder,
                                                    size: "medium",
                                                    fullWidth: true,
                                                    error: validationErrors?.expectedDeliveryDate,
                                                },
                                            }}
                                            value={contractHeadData?.expectedDeliveryDate ? dayjs(contractHeadData.expectedDeliveryDate) : dayjs().add(1, "day")}
                                            minDate={
                                                contractHeadData?.expectedDeliveryDate
                                                    ? dayjs(contractHeadData.expectedDeliveryDate)
                                                    : dayjs().add(1, "day")
                                            }
                                            format="DD-MM-YYYY"
                                            onChange={(date: any) => {
                                                setContractHeadData((prevData) => ({
                                                    ...prevData,
                                                    expectedDeliveryDate: date,
                                                }));
                                                resetValidationError("expectedDeliveryDate");
                                            }}
                                            sx={{
                                                backgroundColor: "#f6f6f6",
                                            }}
                                        />
                                        <FormHelperText
                                            error={validationErrors?.expectedDeliveryDate}
                                        >
                                            {validationErrors?.expectedDeliveryDate}
                                        </FormHelperText>
                                    </LocalizationProvider>

                                </span>
                            </CustomTooltip>
                        </Box>
                    </Stack> */}

          <Stack
            px={2}
            direction={{ md: "row", xs: "column" }}
            py={1}
            spacing={2}
          >
            <Box
              sx={{
                px: 4,
                width: { md: "50%", xs: "100%" },
              }}
            >
              <Typography fontWeight={700} fontSize={16}>
                {CONTRACT_WIZARD_ITEMS?.CONTRACT_TERMS?.label}
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                name="termsNConditions"
                placeholder={CONTRACT_WIZARD_ITEMS?.CONTRACT_TERMS?.placeholder}
                value={contractHeadData?.termsNConditions || ""}
                onChange={(event: any) => {
                  setContractHeadData((prevData) => ({
                    ...prevData,
                    termsNConditions: event?.target?.value,
                  }));
                  resetValidationError("termsNConditions");
                }}
                sx={{
                  backgroundColor: "#f6f6f6",
                }}
                error={validationErrors?.termsNConditions}
              />
              <FormHelperText error={validationErrors?.termsNConditions}>
                {validationErrors?.termsNConditions}
              </FormHelperText>
            </Box>

            <Box
              sx={{
                px: 4,
                width: { md: "50%", xs: "100%" },
              }}
            >
              <Typography fontWeight={700} fontSize={16}>
                {CONTRACT_WIZARD_ITEMS?.CONTRACT_PAYMENT_TERMS?.label}
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                name="paymentTerms"
                placeholder={
                  CONTRACT_WIZARD_ITEMS?.CONTRACT_PAYMENT_TERMS?.placeholder
                }
                value={contractHeadData?.paymentTerms || ""}
                onChange={(event: any) => {
                  setContractHeadData((prevData) => ({
                    ...prevData,
                    paymentTerms: event?.target?.value,
                  }));
                  resetValidationError("paymentTerms");
                }}
                sx={{
                  backgroundColor: "#f6f6f6",
                }}
                error={validationErrors?.paymentTerms}
              />
              <FormHelperText error={validationErrors?.paymentTerms}>
                {validationErrors?.paymentTerms}
              </FormHelperText>
            </Box>
          </Stack>

          <Stack px={2} direction={{ md: "row", xs: "column" }} py={1}>
            <Stack px={4} width={{ md: "50%", xs: "100%" }}>
              <Typography fontWeight={700} fontSize={16}>
                {CONTRACT_WIZARD_ITEMS?.CONTRACT_LIMIT?.label}
              </Typography>
              <TextField
                fullWidth
                type="number"
                name="rateContractAmountLimit"
                placeholder={CONTRACT_WIZARD_ITEMS?.CONTRACT_LIMIT?.placeholder}
                value={contractHeadData?.rateContractAmountLimit || ""}
                onChange={(event: any) => {
                  setContractHeadData((prevData) => ({
                    ...prevData,
                    rateContractAmountLimit: event?.target?.value,
                  }));
                  resetValidationError("rateContractAmountLimit");
                }}
                sx={{
                  backgroundColor: "#f6f6f6",
                }}
                error={validationErrors?.rateContractAmountLimit}
              />
              <FormHelperText error={validationErrors?.rateContractAmountLimit}>
                {validationErrors?.rateContractAmountLimit}
              </FormHelperText>
            </Stack>
          </Stack>

          <Stack px={2} direction={{ md: "row", xs: "column" }} py={1}>
            <Stack px={4}>
              <Typography fontWeight={700} fontSize={16}>
                {CONTRACT_WIZARD_ITEMS?.CONTRACT_LOCATION?.label}
              </Typography>
              <Stack
                direction={"row"}
                spacing={1}
                display={"flex"}
                flexWrap={"wrap"}
              >
                {contractHeadData?.locations?.map(
                  (value: any, index: number) => {
                    return (
                      <Chip
                        variant="outlined"
                        sx={{ color: "#22438C", borderColor: "#22438C" }}
                        key={value}
                        label={value}
                        onDelete={() => {
                          setContractHeadData({
                            ...contractHeadData,
                            locations: contractHeadData?.locations?.filter(
                              (val, ind) => ind != index
                            ),
                          });
                        }}
                        deleteIcon={
                          <ClearOutlined sx={{ color: "#22438C !important" }} />
                        }
                      />
                    );
                  }
                )}
              </Stack>
              {(!contractHeadData?.locations ||
                contractHeadData?.locations?.length === 0) && (
                <Typography>None</Typography>
              )}
            </Stack>
          </Stack>

          {/* <Stack px={2} direction={"row"} spacing={2}>
                        <Box sx={{
                            px: 4,
                            width: "50%",
                        }}>
                            <Typography variant="subtitle1">
                                {CONTRACT_WIZARD_ITEMS?.CONTRACT_BILLING_ADDRESS?.label}
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                name="billingAddress"
                                placeholder={CONTRACT_WIZARD_ITEMS?.CONTRACT_BILLING_ADDRESS?.placeholder}
                                value={selectedBillingAddress?.detail
                                    ? `${selectedBillingAddress.detail.address1}, ${selectedBillingAddress.detail.city}, ${selectedBillingAddress.detail.state} - ${selectedBillingAddress.detail.pincode}`
                                    : ""}
                                onChange={(event: any) => {
                                    // setContractHeadData((prevData) => ({
                                    //     ...prevData,
                                    //     termsNConditions: event?.target?.value,
                                    // }));
                                    resetValidationError("billingAddress");
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                                sx={{
                                    backgroundColor: '#f6f6f6',
                                }}
                                error={validationErrors?.billingAddress}
                            />
                            <FormHelperText error={validationErrors?.billingAddress}>
                                {validationErrors?.billingAddress}
                            </FormHelperText>
                        </Box>

                        <Box sx={{
                            px: 4,
                            width: "50%",
                        }}>
                            <Typography variant="subtitle1">
                                {CONTRACT_WIZARD_ITEMS?.CONTRACT_SHIPPING_ADDRESS?.label}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={4}
                                    name="shippingAddress"
                                    placeholder={CONTRACT_WIZARD_ITEMS?.CONTRACT_SHIPPING_ADDRESS?.placeholder}
                                    value={selectedShippingAddress?.detail
                                        ? `${selectedShippingAddress.detail.address1}, ${selectedShippingAddress.detail.city}, ${selectedShippingAddress.detail.state} - ${selectedShippingAddress.detail.pincode}`
                                        : ""}
                                    onChange={(event: any) => {
                                        resetValidationError("shippingAddress");
                                    }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    sx={{
                                        backgroundColor: '#f6f6f6',
                                    }}
                                    error={validationErrors?.shippingAddress}
                                />
                                
                            </Box>

                            <FormHelperText error={validationErrors?.shippingAddress}>
                                {validationErrors?.shippingAddress}
                            </FormHelperText>



                        </Box>


                    </Stack> */}

          <Box
            sx={{
              py: 4,
            }}
          >
            <RateContractInputTable
              orderHeaderData={contractHeadData}
              setOrderHeadData={setContractHeadData}
              handleAddOrderRow={handleAddContractRow}
              ITEM_UOMs={itemUom}
              validationErrors={validationErrors}
              resetValidationErrors={resetValidationError}
              setError={setError}
              products={products}
              adjustments={adjustments}
              setAdjustments={setAdjustments}
            />
            {validationErrors["itemsSize"] &&
              contractHeadData.items.length === 0 && (
                <Typography px={2} color={"#D32F2F"}>
                  {"*" + validationErrors["itemsSize"]}
                </Typography>
              )}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              gap: {
                xs: 1,
                sm: 4,
              },
              my: 2,
              px: 6,
              py: 2,
            }}
          >
            <Button
              disabled={isLoading}
              onClick={() => handleValidations("ORDER_CREATE")}
              sx={{
                borderRadius: 0,
                backgroundColor: "#22438C",
                color: "white",
                px: {
                  xs: 2,
                  sm: 6,
                },
                py: 2,
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#0060a1",
                },
                minWidth: "220px",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              {isLoading ? (
                <CustomSpinner size={"2rem"} color="secondary" />
              ) : isEdit ? (
                "Save Contract"
              ) : (
                "Create Contract"
              )}
            </Button>
            <Button
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 0,
                backgroundColor: "#f0f0f0",
                color: "#22438C",
                px: {
                  xs: 2,
                  sm: 6,
                },
                py: 2,
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#e4e4e4",
                },
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Cancel
            </Button>
          </Box>
        </Collapse>
      </Box>
      <ErrorPopup
        open={error.open}
        message={error.message}
        onClose={handleCloseError}
      />

      {/* <AddressDialog
                addresses={addressList}
                open={openAddressListDialog.open}
                onClose={() => setOpenAddressListDialog({ ...openAddressListDialog, open: false })}
                onAddNewAddress={handleAddAddress}
                onEditAddress={handleEditAddress}
                onSelectAddress={handleSelectAddress}
                header={openAddressListDialog?.selectedQuote?.fromPartyId?.details
                    ?.groupName + " | GST:" + openAddressListDialog?.selectedQuote?.fromPartyId?.details
                        ?.gstNumber}
            /> */}

      <TermsConditionsBar
        messageType="HSN_AI"
        open={openHsn}
        setOpen={setOpenHsn}
        handleNext={() =>
          isEdit
            ? handleSubmitContract("ORDER_UPDATE")
            : handleSubmitContract("ORDER_CREATE")
        }
        handleCancel={() => {}}
      />
    </Box>
  );
};

export default RateContractWizard;
